<template>
  <div>
    <div class="description">
      変数をクリックするとテキストがコピーされます。変数を挿入したい箇所にペーストしてください。<br />挿入した変数は、実際のアカウント名などに変換されます。
    </div>
    <div class="description">
      <el-tooltip :enterable="false" placement="top" content="クリックしてコピーします。">
        <div class="convert" @click="copyToClipboard('_account_name_')">_account_name_</div> </el-tooltip
      >アカウント名(変換例: コムニコ)
    </div>
    <div class="description">
      <el-tooltip :enterable="false" placement="top" content="クリックしてコピーします。">
        <div class="convert" @click="copyToClipboard('_screen_name_')">_screen_name_</div> </el-tooltip
      >スクリーン名(変換例: comnico)
    </div>
    <div class="description">
      <el-tooltip :enterable="false" placement="top" content="クリックしてコピーします。">
        <div class="convert" @click="copyToClipboard('_account_id_')">_account_id_</div> </el-tooltip
      >アカウントID(変換例: 21950697)
    </div>
    <div class="description">
      <el-tooltip :enterable="false" placement="top" content="クリックしてコピーします。">
        <div class="convert" @click="copyToClipboard('_serial_code_')">_serial_code_</div>
      </el-tooltip>
      <template v-if="isInstantwin"
        >シリアルコード(※利用できるシリアルコードがない場合、強制的に落選となります)</template
      >
      <template v-if="!isInstantwin"
        >シリアルコード(シリアルコードの管理画面で追加した一意のシリアルコードを表示します)</template
      >
      <template v-else>シリアルコード(すでにコードを送っている場合、新しいコードが割り当てられます。)</template>
      <div class="message message-warning mt-x1" v-if="isWebInstantwin">
        シリアルコードを表示する場合、割り当てられるWEBページ用シリアルコードが0件になった時点で、残り当選数に関わらずすべての応募が落選となります。<br />シリアルコードを表示しない場合は、シリアルコードの登録数に関わらず、残り当選数に応じて抽選を行ないます。
      </div>
      <div class="message message-warning mt-x1" v-else-if="isWebIwWinDm">
        WEBページ上で表示済みのシリアルコードがある場合、同じシリアルコードがDMで送信されます。<br />シリアルコードが未割り当てのアカウントには、新しく当選DM用のシリアルコードが割り当てられます。
      </div>
      <div class="message message-warning mt-x1" v-else-if="isWebIwRemindDm">
        リマインドを送信する場合は、割り当てタイミングがWEBページか当選DMかに関わらず、割り当て済のコードが送られます。
      </div>
      <div class="message message-warning mt-x1" v-else-if="isCampaignRemindDm">
        リマインドを送信する場合は、割り当て済のシリアルコードが送られます。
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.description {
  margin: $spacing-unit 0 0;
  color: $sub-text-color;
}

.convert {
  display: inline-block;
  padding: 2px;
  margin: 0 $spacing-unit 0 0;
  font-size: $font-size;
  line-height: initial;
  color: $text-color-white;
  cursor: pointer;
  background: rgba($info-color, 0.8);
  border: 0;
  border-radius: $round;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue'

import Util from '@/client/core/util'
import { TrackingService } from '@/client/services'

export default defineComponent({
  props: {
    isWebInstantwin: {
      type: Boolean,
      default: false
    },
    isWebIwRemindDm: {
      type: Boolean,
      default: false
    },
    isWebIwWinDm: {
      type: Boolean,
      default: false
    },
    isCampaignRemindDm: {
      type: Boolean,
      default: false
    },
    isInstantwin: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * クリップボードにコピーする
     * @param {string} text
     */
    copyToClipboard(text: string) {
      switch (text) {
        case '_account_name_':
          if (this.type === 'templateDialog') {
            TrackingService.sendEvent('click:テンプレート|テンプレートの編集|account_name')
          } else TrackingService.sendEvent('click:当選メッセージの管理|メッセージの新規作成|account_name')
          break
        case '_screen_name_':
          if (this.type === 'templateDialog') {
            TrackingService.sendEvent('click:テンプレート|テンプレートの編集|screen_name')
          } else TrackingService.sendEvent('click:当選メッセージの管理|メッセージの新規作成|screen_name')
          break
        case '_account_id_':
          if (this.type === 'templateDialog') {
            TrackingService.sendEvent('click:テンプレート|テンプレートの編集|account_id')
          } else TrackingService.sendEvent('click:当選メッセージの管理|メッセージの新規作成|account_id')
          break
        case '_serial_code_':
          if (this.type === 'templateDialog') {
            TrackingService.sendEvent('click:テンプレート|テンプレートの編集|serial_code')
          } else TrackingService.sendEvent('click:当選メッセージの管理|メッセージの新規作成|serial_code')
          break
        default:
          break
      }

      Util.copyToClipboard(text)
      this.$message({
        message: `${text}をクリップボードにコピーしました。`,
        type: 'success'
      })
    }
  }
})
</script>
